'use strict';

// Template Editor
angular.module('risevision.template-editor.services', []);

angular.module('risevision.apps', [
    'ui.router',
    'ui.router.upgrade',
    'risevision.common.config',
    'risevision.common.header',
    'risevision.common.components',
    'risevision.common.components.loading',
    'risevision.common.components.scrolling-list',
    'risevision.common.components.logging',
    'risevision.apps.services',
    'risevision.apps.controllers',
    'risevision.apps.directives',
    'risevision.schedules.services',
    'risevision.editor.services',
    'risevision.storage.services',
    'risevision.storage.controllers',
    'risevision.storage.directives',
    'risevision.storage.filters',
    'risevision.template-editor.services'
  ])
  .run(['$window',
    function ($window) {
      if ($window.Stretchy && $window.Stretchy.selectors) {
        $window.Stretchy.selectors.filter = '.input-stretchy, .input-stretchy *';
      }
    }
  ])
  .run(['$rootScope', '$state', '$location', '$transitions', '$exceptionHandler',
    'rvShareAppDetection',
    function ($rootScope, $state, $location, $transitions, $exceptionHandler,
      rvShareAppDetection) {

      $transitions.onError({}, function(transition) {
        var error = transition.error();

        // angular-ui-router/stateEvents.js:37 - Ignored (and Invalid) transitions are not handled
        // angular-ui-router/stateEvents.js:200 - Superseded and Aborted transitions are not thrown
        if (error && (error.type === 2 /* RejectType.SUPERSEDED */ || error.type === 3 /* RejectType.ABORTED */ || error.type === 5 /* RejectType.IGNORED */)) {
          // 'superseded' type errors caused by 'redirectTo:'
          return;
        } else if (error && error.detail === 'unauthenticated') {
          return;
        } else if (error && error.detail && error.detail.status === 404) {
          if (!transition.from().name) {
            transition.router.stateService.go('apps.home', transition.params(), {
              location: 'replace'
            });
          }
        }

        $exceptionHandler(error, 'UI Router Error.', true);
      });

      $transitions.onBefore({
        to: (state) => {
          const isEnabledForApp =
            state.data && state.data.rvshareAppEnabled !== undefined ? state.data.rvshareAppEnabled
              : false;
          return !isEnabledForApp;
        },
      }, () => !rvShareAppDetection.isScreenShareApp());

      $rootScope.$on('risevision.company.selectedCompanyChanged', function () {
        if ($state.current.name === 'apps.schedules.list' ||
          $state.current.name === 'apps.editor.list' ||
          $state.current.name === 'apps.displays.list' ||
          $state.current.name === 'apps.displays.alerts' ||
          $state.current.name === 'apps.storage.home' ||
          $state.current.name === 'apps.company.details' ||
          $state.current.name === 'apps.company.licenses' ||
          $state.current.name === 'apps.user.list' ||
          $state.current.name === 'apps.screen-sharing.moderator-join' ||
          $state.current.name === 'apps.home') {

          $state.go($state.current, $state.params, {
            reload: true
          });
        } else if (($state.current.name.indexOf('apps.purchase') !== -1 ||
            $state.current.name.indexOf('apps.billing') !== -1) &&
            ($state.current.forceAuth !== false &&
            (!$state.current.params || $state.current.params.forceAuth !== false))) {
          $state.go('apps.billing.home', $state.params, {
            reload: true
          });
        } else if (($state.current.name === 'apps.editor.templates.edit')) {
          if ($state.params.cid !== $location.search().cid) {
            $state.go('apps.editor.list', $state.params);
          }
        }
      });
    }
  ]);
